import {HasTenantResource, ResourceConfig, SoftDeleteResource} from "@hidat/huijs-resource";
import {FieldConfig, FieldDataTypes, uBoolean, uNumber, uString, Uuid} from "@hidat/huijs-common";
import {RblFieldConfigs, RblResourceInterface} from "../rbl-resource.interface";

export const BinConfig = new ResourceConfig('Bin', 'bins', true, true)
  .addFields([
    RblFieldConfigs.id,
    RblFieldConfigs.uid,
    RblFieldConfigs.bin,
    RblFieldConfigs.createdAt,
    new FieldConfig('name'),
    new FieldConfig('shortCode'),
    new FieldConfig('binKlass'),
    new FieldConfig('binExtended', FieldDataTypes.UNKNOWN),
    new FieldConfig('allowDuplicates', FieldDataTypes.BOOLEAN),
    new FieldConfig('isOrdered', FieldDataTypes.BOOLEAN),
    new FieldConfig('trackChanges', FieldDataTypes.BOOLEAN),
  ])
.setSorts({
  name: 'name'
})
.setDefaultSort('name')

export interface BinInterface extends RblResourceInterface<number>, HasTenantResource {
  uid: Uuid | undefined,
  name: uString,
  externalCode: uString;
  parentBinId: uNumber;
  binKlass: uString,   //rename to prototype?
  isRootBin: uBoolean;
  rootBinId: uNumber;
  type: uString;  //rails specific???
  accessLevel: uNumber;
  listCount: uNumber;
  libraryCount: uNumber;
  binCount: uNumber;
  linkCount: uNumber;
}
